<template>
    <div>
        <Header/>
        <MainPage/>
        <Footer/>
    </div> 
</template>
<script>
import Header from './website/header/Header';
import MainPage from './website/main/MainPage';
import Footer from './website/footer/Footer';


export default {
    components: {
        Header,
        MainPage,
        Footer
    }
}
</script>